import {CSSProperties, FC} from 'react';


export interface IIconHeightProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconHeight: FC<IIconHeightProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M14.2 16.333H5.8v.584a.592.592 0 0 1-.6.583h-.6a.592.592 0 0 1-.6-.583v-5.834l1.488-3.376c.19-.43.624-.707 1.104-.707h6.816c.48 0 .914.278 1.103.707L16 11.083v5.834a.592.592 0 0 1-.6.583h-.6a.592.592 0 0 1-.6-.583v-.584Zm.6-4.083H5.2v2.917h9.6V12.25Zm-9.494-1.167h9.388L13.41 8.167H6.592l-1.286 2.916Zm1.394 3.5a.888.888 0 0 1-.9-.875c0-.483.403-.875.9-.875s.9.392.9.875a.888.888 0 0 1-.9.875Zm6.6 0a.888.888 0 0 1-.9-.875c0-.483.403-.875.9-.875s.9.392.9.875a.888.888 0 0 1-.9.875Z" clipRule="evenodd" />
            <path d="M3 4H21V5H3z" />
            <path d="M3 19H21V20H3z" />
            <path d="M19 7h1v10h-1V7Z" />
            <path d="m19.5 6 1.299 1.5h-2.598L19.5 6ZM19.5 18l-1.299-1.5h2.598L19.5 18Z" />
        </svg>
    );
};
